import {axios} from "@/main";

export default class {
    static async getAuthUrl (state) {
        return await axios.get(
            process.env.VUE_APP_REST_API + `google/account/auth-uri?state=${state}`
        )
    }
    static async connect (code) {
        return await axios.post(
            process.env.VUE_APP_REST_API + `google/account/connect`,
            {
                code: code
            }
        )
    }
}
